// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__tCZED","cardTitle":"styles_cardTitle__vWOSc","buttonWrapper":"styles_buttonWrapper__3jPFw","imgRandom":"styles_imgRandom__62zlM"};